import React from 'react'
import {
  Icon,
  Tag,
  message,
  Modal,
  Button,
  Select,
  Empty,
  Skeleton,
} from 'antd'

import prettysize from '../../../../utils'
import moment from 'moment'

import './styles.scss'

class CostlyTransfers extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { error, loading, data } = this.props

    const emptyPanel = (
      <div className="empty-panel">
        <Empty />
      </div>
    )
    const errorPanel = (
      <div className="error-panel">
        <h1>
          <Icon type="frown" />
          <span> Could not load data.</span>
        </h1>
      </div>
    )
    const loadingPanel = (
      <Skeleton title={false} paragraph={{ rows: 8, width: '100%' }} active />
    )

    const costlyTransfersPanel = (
      <div>
        <div className="costly-transfers-header">
          <h1 className="title">Transfer Costs</h1>
        </div>
        <div className="costly-transfers-entries">
          {data.map(entry => (
            <Entry
              key={`${entry.date}_${entry.via}`}
              date={moment(entry.date).format('MMM - Do')}
              size={prettysize(entry.size)}
              amount={entry.amount}
              via={entry.via}
            />
          ))}
        </div>
      </div>
    )

    let panel

    if (error) panel = errorPanel
    else if (loading) panel = loadingPanel
    else if (!data.length) panel = emptyPanel
    else panel = costlyTransfersPanel

    return <div className="costly-transfers">{panel}</div>
  }
}

const Entry = ({ date, size, amount, via }) => (
  <div className="entry">
    <div className="date">
      <Tag color="gray">{date}</Tag>
    </div>
    <div className="size">{size}</div>
    <div className="amount">
      <span className="dollar-sign">$ </span>
      <span className="number">{amount}</span>
    </div>
    <div className="via">{via}</div>
  </div>
)

export default CostlyTransfers
